import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle, SkeletonLine } from '@wix/design-system';
import s from '../TemplateCard.module.scss';
const TemplateLoadingCard = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    componentHeight = '322px',
    skeletonHeight,
    noBackground
  } = _ref;
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light"
  }, /*#__PURE__*/React.createElement(Box, {
    className: noBackground ? s.noBackgroundTemplate : s.template,
    direction: "vertical",
    minWidth: "218px",
    height: componentHeight,
    padding: noBackground ? '0px' : '12px',
    overflow: "hidden",
    borderRadius: "4px"
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: skeletonHeight ? '' : s.skeletonRectStyle
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    height: skeletonHeight
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    width: "100%",
    align: "space-between"
  }, /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "132px",
    marginTop: "12px"
  }), /*#__PURE__*/React.createElement("div", {
    className: s.skeletonLineStyle
  }, /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "32px",
    marginTop: "12px"
  }))), /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "132px",
    marginTop: "4px"
  }), /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "46px",
    marginTop: "36px"
  })));
});
export default TemplateLoadingCard;
//# sourceMappingURL=TemplateLoadingCard.js.map